import React from 'react';

export const Phone: React.FC = () => {
  return (
    <div
      style={{
        width: 1179 / 3.4,
        height: 2556 / 3.4,
        borderWidth: 8,
        borderStyle: 'solid',
        borderColor: '#193364',
        borderRadius: 29,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          borderRadius: 20,
        }}
      >
        <iframe
          src='https://stephub-pwa.vercel.app/'
          width='100%'
          height='100%'
          style={{
            border: 0,
            borderRadius: 12,
            overflow: 'scroll',
            scrollbarWidth: 'none' /* Firefox */,
            msOverflowStyle: 'none' /* IE 10+ */,
          }}
          allowFullScreen={true} // Исправлено на правильное название атрибута
        ></iframe>
      </div>
    </div>
  );
};
